import axios from 'axios';
import RestService from '../../../helpers/RestService';


axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export async function getDiscounts() {
  try {
    const {data} = await axios.get('/api/discounts/get');
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}


export async function createDiscount(body) {
  try {
    const {data} = await axios.post('/api/discount/post', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}


export async function updateDiscount(body) {
  try {
    const {data} = await axios.post('/api/discount/patch', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}




export async function deleteDiscount(body) {
  try {
    const {data} = await axios.post('/api/discount/delete', body);
    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    return Promise.reject({message: 'Bag request'})
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Discounts/actions.js